export default function Bio() {
  return (
    <main className='page'>
      <section className='bioContainer'>
        <article>

          <p>
            Founded by self-taught multi-instrumentalist and producer Patrick Park (b. 1990) in 2009,
            having already had produced other styles of music for seven years, <i>Tegara</i> is an experimental
            death/groove metal project with various influences.
            Lyrics, vocals, composition, recording, drum programming, mixing and mastering
            all by Patrick, unless stated otherwise in discography comments.
          </p>

          <h2>Gear</h2>

          <ul>
            <li>Strandberg Boden 8 White Classic</li>
            <li>Cort Stratocaster</li>
            <li>Sojing hollowbody bass guitar</li>
            <li>DR strings</li>
            <li>Elixir strings</li>
            <li>Line 6 UX1</li>
            <li>Yamaha HS7</li>
            <li>AKG K702</li>
            <li>Shure C606</li>
            <li>HP ZBook G7</li>
            <li>Reaper DAW</li>
          </ul>
        </article>
      </section>
    </main>
  );
}
